import axios from 'axios'
import axiosIns from '@/libs/axios'

export default {
  namespaced: true,
  state: {
    services: [],
  },
  getters: {
    services: state => state.services,
  },
  mutations: {
    SET_SERVICES: (state, services) => { state.services = services },
  },
  actions: {
    fetchServices({ commit }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get('/services')
          .then(response => {
            const { data } = response.data
            commit('SET_SERVICES', data)
            resolve(data)
          })
          .catch(error => reject(error))
      })
    },
    async addService(ctx, { service, icon }) {
      const preSignedUrl = await axiosIns.get('/signed-urls', { params: { fileName: icon.name } })
      console.log(preSignedUrl, 'URL')
      const { url } = preSignedUrl.data.data
      await axios.put(url, icon, { headers: { 'Content-Type': icon.type } })
      await axiosIns.post('/services', { ...service, iconUrl: url })
    },
    async updateService(ctx, { service, icon }) {
      const body = { ...service }
      if (icon) {
        const preSignedUrl = await axiosIns.get('/signed-urls', { params: { fileName: icon.name } })
        let url = preSignedUrl.data.data
        await axios.put(url, icon, { headers: { 'Content-Type': icon.type } })
        url = new URL(url)
        body.iconUrl = url.origin + url.pathname
      }

      await axiosIns.post('/services', body)
    },
  },
}
